<template>
    <div class="small-form">
        <SearchAddress
            v-for="(index) in [0, 1]"
            :key="index"
            :store="store"
            :index="index"
            :Api="Api"
            :isOpen="true"
        />
        <button class="single-button" @click="store.stateFull(true);">Оформить заказ</button>
    </div>
</template>

<script>
    import SearchAddress from '../../elements/SearchAddress';


    export default {
        components: {
            SearchAddress
        },
        props: ["store", "Api"]
    }
</script>

<style lang="scss">
    #yacurier-form {
        .small-form {
            background: #FFF;
            border: 1px solid #f2f6fc;
            box-shadow: 0 14px 20px 0 rgba(164, 182, 206, .5);
            min-width: 400px;
            padding: 30px 25px 25px;
            .search-input-field {
                margin-top: 20px;
                &:first-child {
                    margin-top: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/blocks/SmallForm/Index.vue